import { render, staticRenderFns } from "./PrinterQueue.vue?vue&type=template&id=572636e8&scoped=true"
import script from "./PrinterQueue.vue?vue&type=script&lang=js"
export * from "./PrinterQueue.vue?vue&type=script&lang=js"
import style0 from "./PrinterQueue.vue?vue&type=style&index=0&id=572636e8&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572636e8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSlideYTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VCard,VCardTitle,VContainer,VDataTable,VLayout,VProgressLinear,VSlideYTransition})
